// src/monet-utils/findFirstJust.ts
import { None } from "monet";
import find from "ramda/src/find";
function findFirstJust(a) {
  return find((x) => x.isSome(), a) || None();
}
var findFirstJust_default = findFirstJust;

export {
  findFirstJust_default
};
//# sourceMappingURL=chunk-RI35KOCZ.mjs.map